import "core-js/modules/es.promise.finally.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Spacing from "../../../../../Styled/Spacing";
import { TextSpan } from "../../../../../Styled/Text";
import { Category, ShareAction } from "../../../../../Core/AnalyticEvents/analyticEvents";
import Clipboard from "../../../../Clipboard";
import { buildShareLink, buildShortShareLink } from "../BuildShareLink";
import { ShareUrlWarning } from "./ShareUrlWarning";
import TerriaError, { TerriaErrorSeverity } from "../../../../../Core/TerriaError";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ShareUrl = /*#__PURE__*/forwardRef(function ShareUrl(_ref, forwardRef) {
  let {
    terria,
    viewState,
    includeStories,
    shouldShorten,
    children,
    callback
  } = _ref;
  const {
    t
  } = useTranslation();
  const [shareUrl, setShareUrl] = useState("");
  const [shorteningInProgress, setShorteningInProgress] = useState(false);
  const [placeholder, setPlaceholder] = useState();
  useImperativeHandle(forwardRef, () => ({
    url: shareUrl,
    shorteningInProgress: shorteningInProgress
  }), /* eslint-disable-next-line react-hooks/exhaustive-deps */
  [forwardRef, shareUrl, shorteningInProgress]);
  useEffect(() => {
    let cancelled = false;
    if (shouldShorten) {
      setPlaceholder(t("share.shortLinkShortening"));
      setShorteningInProgress(true);
      buildShortShareLink(terria, viewState, {
        includeStories
      }).then(shareUrl => {
        if (!cancelled) setShareUrl(shareUrl);
      }).catch(error => {
        let userMessage = t("models.shareData.generateErrorMessage");
        if (error instanceof TerriaError) {
          var _highestImportanceErr;
          const highestImportanceError = error.highestImportanceError;
          const highestImportanceOriginalErrorMessage = (_highestImportanceErr = highestImportanceError.originalError) === null || _highestImportanceErr === void 0 ? void 0 : _highestImportanceErr[0].message;
          if (highestImportanceOriginalErrorMessage !== null && highestImportanceOriginalErrorMessage !== void 0 && highestImportanceOriginalErrorMessage.includes("413")) {
            userMessage = t("models.shareData.generateErrorDataExceedsLimitMessage");
            terria.raiseErrorToUser(TerriaError.from(error, {
              message: userMessage
            }), {
              severity: TerriaErrorSeverity.Error
            });
          }
        }
        if (!cancelled) {
          setShareUrl(userMessage);
        }
      }).finally(() => {
        if (!cancelled) setShorteningInProgress(false);
      });
    } else {
      setShareUrl(buildShareLink(terria, viewState, {
        includeStories
      }));
    }
    return () => {
      cancelled = true;
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [terria, viewState, shouldShorten, includeStories]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Explanation, {
      children: t("clipboard.shareExplanation")
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 1
    }), /*#__PURE__*/_jsx(Clipboard, {
      text: shareUrl,
      inputPlaceholder: placeholder,
      createdMessage: includeStories && terria.stories && terria.stories.length > 0 ? t("share.storyLinkCreated") : t("share.shareLinkCreated"),
      onCopy: text => {
        var _terria$analytics;
        return (_terria$analytics = terria.analytics) === null || _terria$analytics === void 0 ? void 0 : _terria$analytics.logEvent(Category.share, ShareAction.storyCopy, text);
      }
    }), children, /*#__PURE__*/_jsx(ShareUrlWarning, {
      terria: terria,
      viewState: viewState,
      callback: callback || (() => {})
    })]
  });
});
const Explanation = styled(TextSpan).withConfig({
  displayName: "ShareUrl__Explanation",
  componentId: "sc-l2hcyd-0"
})(["opacity:0.8;"]);